import React from "react";
import styled from "@emotion/styled";
import { spacing, SpacingProps } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";

import {
  AppBar,
  Button as MuiButton,
  Container,
  Grid,
  Box,
  Toolbar,
} from "@mui/material";

import { ReactComponent as Logo } from "../../../vendor/logo.svg";

import { useTranslation } from "react-i18next";
import useAuth from "../../../hooks/useAuth";

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button = styled(MuiButton)<ButtonProps>(spacing);

const Brand = styled.div`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.typography.fontFamily};
  align-items: center;
  display: flex;
  gap: ${(props) => props.theme.spacing(3)};
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)};
  margin-top: -2px;
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 32px;
  height: 32px;

  vertical-align: middle;
  display: inline;
`;

const AppBarComponent: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized, isLoading } = useAuth();

  return (
    <React.Fragment>
      <AppBar position="relative" color="transparent" elevation={0}>
        <Toolbar>
          <Container>
            <Grid
              container
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid>
                <Brand
                  onClick={() => navigate("/")}
                  style={{ cursor: "pointer" }}
                >
                  <img src="/static/img/logo/horizontal_logo.svg" height={48} />
                  AI Contract Manager
                </Brand>
              </Grid>
              <Grid />

              <Grid
                container
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Box sx={{ display: { xs: "none", md: "inline-block" } }}>
                  <Button
                    ml={2}
                    color="inherit"
                    component={Link}
                    to="/dashboard/analytics"
                    target="_blank"
                    disabled
                  >
                    {t("Product tour")}
                  </Button>
                  <Button
                    ml={2}
                    color="inherit"
                    component={Link}
                    to="/documentation/welcome"
                    target="_blank"
                    disabled
                  >
                    {t("Documentation")}
                  </Button>
                  <Button ml={2} color="inherit" component={Link} to="/pricing">
                    {t("Pricing")}
                  </Button>
                </Box>

                {isAuthenticated ? (
                  <Button
                    ml={2}
                    color="primary"
                    variant="contained"
                    component={Link}
                    to="/home"
                  >
                    {t("View dashboard")}
                  </Button>
                ) : (
                  <>
                    <Button
                      ml={2}
                      color="primary"
                      variant="contained"
                      onClick={() => navigate("/auth/sign-up")}
                    >
                      {t("Create an account")}
                    </Button>

                    <Button
                      ml={2}
                      color="primary"
                      variant="outlined"
                      onClick={() => navigate("/auth/sign-in")}
                    >
                      {t("Sign in")}
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default AppBarComponent;
